const MSAL_INTERACTION_STATUS_KEY_PART = 'interaction.status';

/** Remove only stale MSAL interaction-status entries from session storage. */
export function clearStaleMsalInteractionStatus(storage = sessionStorage) {
  Object.keys(storage)
    .filter((key) => key.includes(MSAL_INTERACTION_STATUS_KEY_PART))
    .forEach((key) => storage.removeItem(key));
}
